import React, { useState } from "react";

import PanelTemplate from "../../../templates/Panel";
import BoxTabs from "../../../components/BoxTabs";
import GestaoSettingsTabs from "../../../components/GestaoSettingsTabs";

import BankAccountsTab from "./tabs/bankAccounts";
import CategoriesTab from "./tabs/categories";
import CostCentersTab from "./tabs/costCenters";
import TransfersTab from "./tabs/transfers";

// Cadastros do módulo financeiro: contas/caixas, plano de contas,
// centros de custo e transferências entre contas.
export const FinanceSettings = () => {
    const [tab, setTab] = useState(0);

    return (
        <PanelTemplate id="finance-settings">
            <GestaoSettingsTabs />
            <BoxTabs
                tab={tab}
                setTab={setTab}
                titles={['Contas e caixas', 'Categorias', 'Centros de custo', 'Transferências']}
                contents={[
                    <BankAccountsTab />,
                    <CategoriesTab />,
                    <CostCentersTab />,
                    <TransfersTab />,
                ]}
            />
        </PanelTemplate>
    );
};

export default FinanceSettings;
